import styled from "styled-components";
import { Select } from "antd";

export const Dropdown = styled.div`
  font-size: 16px;
  display: flex;
  flex-direction: column;
  position: relative;
  transition: all 0.3s ease;
`;

export const DropdownContent = styled.div`
  &.active {
    display: block;
    position: absolute;
    top: 40px;
    @media (min-width: 320px) and (max-width: 768px) {
      width: 100%;
    }
    @media (min-width: 769px) {
      width: max-content;
    }
    background-color: white;
    margin: 0;
    padding: 10px;
    min-height: 32px;
    line-height: 1.5715;
    box-sizing: "border-box";
    border-radius: 2px;
    outline: none;
    box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
    z-index: 2;
  }
  &.disabled {
    display: none;
  }
  &.right {
    right: 0;
  }
  &.left {
    left: 0;
  }
`;

export const StyledRowDiv = styled.div`
  display: flex;
  @media (min-width: 320px) and (max-width: 768px) {
    flex-direction: column;
  }
  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

export const StyledColDiv = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: 320px) and (max-width: 768px) {
    justify-content: space-around;
  }
  @media (min-width: 768px) {
    justify-content: flex-start;
    padding: 0 10px;
  }
  text-align: left;
  font-weight: bold;
  letter-spacing: 0.9px;
  color: rgb(16, 112, 182);
  .language-category-label {
    padding-left: 12px;
    @media (min-width: 768px) {
      font-size: 16px;
      padding-bottom: 20px;
    }
  }
`;
export const StyledContainer = styled.div`
  @media (max-width: 768px) and (min-width: 425px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    width: 100%;
    margin-bottom: 12px;
  }
  input[type="radio"] {
    opacity: 0;
    position: fixed;
    width: 0;
  }
  .labels {
    color: #6e7782;
    cursor: pointer;
    font-weight: lighter;
  }
  input[type="radio"] + label {
    display: block;
    font-weight: 600;
    padding: 5px 12px;
  }
  input[type="radio"]:checked + label {
    background-color: #d3e6ff;
  }
`;
export const DropBtn = styled.button`
&.no-col {
  @media (min-width: 768px) {
    width: 251px;
  }
}
&.inside-col {
  @media (min-width: 320px) and (max-width: 768px) {
    width: calc(100vw-8%);
  }
  @media (min-width: 769px) {
    width: calc(100vw-8%)/4;
  }
}
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  transition: all 0.3s;
  height: 36px;
  text-align: left;
  padding: 0 16px;
  &:hover, &:active, &:focus {
    border: 1px solid #1070b6;
  }
  .value-dropdown {
    color: black;
    justify-content: center;
    left: 11px;
    letter-spacing: 0.9px;
    line-height: 22.001px;
    font-size: 14px;
    font-weight 400px;
    pointer-events: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .value-dropdown-icon {
    height: 12px;
    color: rgba(0, 0, 0, 0.25);
    font-size: 12px;
    pointer-events: none;
  }
`;

export const FilterSelect = styled(Select)`
  height: 36px;
  font-size: 14px;
  color: black;
  white-space: normal;

  &.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    height: 100%;
    background-color: #ffffff;
    justify-content: center;
    text-align: left;
    display: flex;
    align-items: center;
    padding: 0px 16px;
  }

  &.ant-select-single:not(.ant-select-customize-input)
    .ant-select-selector::placeholder {
    color: #707070;
  }

  & .ant-select-arrow {
    margin-right: 8px;
  }

  &.ant-select-single.ant-select-show-arrow .ant-select-selection-search {
    justify-content: center;
    display: flex;
    align-items: center;
  }
`;

export const LanguageSelect = styled(FilterSelect)`
  width: 100%;
  font-weight: normal;
`;
